import { Injectable } from '@angular/core'

export enum LocalStorageKey {
  LIBRARY__SHOW_ALL_RATE_CARD_ITEMS = 'showAllRateCardItems',
}

@Injectable({ providedIn: 'root' })
export class LocalStorageService {
  set(key: string, value: string) {
    localStorage.setItem(key, String(value))
  }

  get(key: string) {
    return localStorage.getItem(key)
  }

  remove(key: string) {
    return localStorage.removeItem(key)
  }
}
